import React, { useMemo } from 'react';
import { SearchSelect } from '../search-select';
import { useTimezone } from './TimezoneContext';
import { TIMEZONE_FALLBACK } from './utils';
function getOffsetLabel(tz) {
    var _a, _b;
    try {
        const parts = new Intl.DateTimeFormat('en', {
            timeZone: tz,
            timeZoneName: 'shortOffset',
        }).formatToParts(new Date());
        return (_b = (_a = parts.find((p) => p.type === 'timeZoneName')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    }
    catch {
        return '';
    }
}
function buildTimezoneOptions() {
    var _a, _b, _c;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const zones = (_c = (_b = (_a = Intl).supportedValuesOf) === null || _b === void 0 ? void 0 : _b.call(_a, 'timeZone')) !== null && _c !== void 0 ? _c : TIMEZONE_FALLBACK;
    return zones.map((tz) => ({
        value: tz,
        label: tz.replace(/_/g, ' '),
        sub: getOffsetLabel(tz),
    }));
}
export function TimezonePicker({ className, label }) {
    const { timezone, setTimezone } = useTimezone();
    const options = useMemo(() => buildTimezoneOptions(), []);
    return (React.createElement("div", { className: className },
        label && (React.createElement("label", { className: "mb-1 block text-xs font-medium text-stone-500" }, label)),
        React.createElement(SearchSelect, { options: options, value: timezone, onChange: (val) => setTimezone(val), variant: "dropdown", placeholder: "Select timezone...", searchPlaceholder: "Search timezone... (e.g. Asia/Ho)" })));
}
